/* eslint-disable */
import type * as Types from '../../../../graphql/gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CorePropMetricsFieldsFragment = { __typename: 'PropRecReview', adr?: number | undefined, adr_lyst?: number | undefined, available_rooms?: number | undefined, current_otb?: number | undefined, current_otb_lyf?: number | undefined, current_rate?: number | undefined, current_revenue?: number | undefined, event_id?: string | undefined, fcst_occ_pct?: number | undefined, fcst_rev?: number | undefined, fcst_rev_rec?: number | undefined, group_blocked?: number | undefined, group_booked?: number | undefined, market_rate?: number | undefined, occ_pct?: number | undefined, occ_pct_lyf?: number | undefined, out_of_order?: number | undefined, override_rate?: number | undefined, pkp_day_1?: number | undefined, prev_rec_rate?: number | undefined, property_id?: string | undefined, rec_rate?: number | undefined, stay_date: string, total_capacity?: number | undefined, total_fcst?: number | undefined, transient_fcst?: number | undefined, transient_fcst_event?: number | undefined, yoy_rate_lyst?: number | undefined };

export type CoreRateLevelFieldsFragment = { __typename: 'PropRateLevels', a_current_otb?: number | undefined, a_fcst_sell?: number | undefined, a_rate_level?: string | undefined, a_status?: string | undefined, a_rec_action?: string | undefined, b_current_otb?: number | undefined, b_fcst_sell?: number | undefined, b_rate_level?: string | undefined, b_status?: string | undefined, b_rec_action?: string | undefined, c_current_otb?: number | undefined, c_fcst_sell?: number | undefined, c_rate_level?: string | undefined, c_status?: string | undefined, c_rec_action?: string | undefined, d_current_otb?: number | undefined, d_fcst_sell?: number | undefined, d_rate_level?: string | undefined, d_status?: string | undefined, d_rec_action?: string | undefined, e_current_otb?: number | undefined, e_fcst_sell?: number | undefined, e_rate_level?: string | undefined, e_status?: string | undefined, e_rec_action?: string | undefined, f_current_otb?: number | undefined, f_fcst_sell?: number | undefined, f_rate_level?: string | undefined, f_status?: string | undefined, f_rec_action?: string | undefined, g_fcst_sell?: number | undefined, g_current_otb?: number | undefined, g_rate_level?: string | undefined, g_status?: string | undefined, g_rec_action?: string | undefined, h_current_otb?: number | undefined, h_fcst_sell?: number | undefined, h_rate_level?: string | undefined, h_status?: string | undefined, h_rec_action?: string | undefined };

export type GetUserSearchesQueryVariables = Types.Exact<{
  userId: Types.Scalars['String'];
}>;


export type GetUserSearchesQuery = { __typename?: 'Query', getUserSearches?: Array<{ __typename?: 'UserSearch', isEditable?: boolean | undefined, duration?: number | undefined, endDate?: string | undefined, searchId?: number | undefined, searchName?: string | undefined, searchType?: string | undefined, selectedDays?: Array<string | undefined> | undefined, startDate?: string | undefined, statuses?: Array<string | undefined> | undefined, userId?: string | undefined, searchCriteria?: Array<{ __typename?: 'UserSearchCriteria', lhsCode?: string | undefined, operatorCode?: string | undefined, rhsCode?: string | undefined, rhsCustomValue?: number | undefined, searchId?: number | undefined } | undefined> | undefined } | undefined> | undefined };

export type GetPropertyByPropertyIdQueryVariables = Types.Exact<{
  propertyId: Types.Scalars['String'];
}>;


export type GetPropertyByPropertyIdQuery = { __typename?: 'Query', getPropertyByPropertyId?: { __typename?: 'Property', property_id?: string | undefined, search_name?: string | undefined, currency_code?: string | undefined, full_history_avail_ind?: boolean | undefined } | undefined };

export type GetPropertiesQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String'];
}>;


export type GetPropertiesQuery = { __typename?: 'Query', getProperties?: Array<{ __typename?: 'Property', search_name?: string | undefined, property_id?: string | undefined, currency_code?: string | undefined } | undefined> | undefined };

export type GetSelloutIndicatorsQueryVariables = Types.Exact<{
  propertyId: Types.Scalars['String'];
  stayDate: Types.Scalars['String'];
}>;


export type GetSelloutIndicatorsQuery = { __typename?: 'Query', getSelloutReasons?: Array<string | undefined> | undefined };

export type SaveSearchMutationVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.SearchInput>;
}>;


export type SaveSearchMutation = { __typename?: 'Mutation', saveSearch?: { __typename?: 'UserSearch', isEditable?: boolean | undefined, duration?: number | undefined, endDate?: string | undefined, searchId?: number | undefined, searchName?: string | undefined, searchType?: string | undefined, selectedDays?: Array<string | undefined> | undefined, startDate?: string | undefined, statuses?: Array<string | undefined> | undefined, userId?: string | undefined, searchCriteria?: Array<{ __typename?: 'UserSearchCriteria', lhsCode?: string | undefined, operatorCode?: string | undefined, rhsCode?: string | undefined, rhsCustomValue?: number | undefined, searchId?: number | undefined } | undefined> | undefined } | undefined };

export type DeleteSearchMutationVariables = Types.Exact<{
  searchId?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type DeleteSearchMutation = { __typename?: 'Mutation', deleteSearch?: { __typename?: 'DeleteSearchResult', success?: boolean | undefined, message?: string | undefined } | undefined };

export type ToggleFavoriteStayNightMutationVariables = Types.Exact<{
  propertyId: Types.Scalars['String'];
  stayDate: Types.Scalars['String'];
  userId: Types.Scalars['String'];
}>;


export type ToggleFavoriteStayNightMutation = { __typename?: 'Mutation', favoriteStayNight?: { __typename?: 'PropUserFavNight', stay_date?: string | undefined, is_favorite?: boolean | undefined, property_id?: string | undefined, user_id?: string | undefined } | undefined };

export type GetSearchMetricsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSearchMetricsQuery = { __typename?: 'Query', getSearchMetrics?: Array<{ __typename?: 'SearchMetric', lhsCode?: string | undefined, lhsName?: string | undefined, operator?: Array<{ __typename?: 'KeyPair', code?: string | undefined, value?: string | undefined } | undefined> | undefined, rhs?: Array<{ __typename?: 'KeyPair', code?: string | undefined, value?: string | undefined } | undefined> | undefined } | undefined> | undefined };

export type GetRecReviewDataQueryVariables = Types.Exact<{
  propertyId?: Types.InputMaybe<Types.Scalars['String']>;
  input?: Types.InputMaybe<Types.SearchInfo>;
}>;


export type GetRecReviewDataQuery = { __typename?: 'Query', PropMetrics?: { __typename?: 'PropRecReviewResponse', result_rows?: number | undefined, results: Array<{ __typename: 'PropRecReview', adr_lyf?: number | undefined, available_cap?: number | undefined, con_dmd_curr_rate?: number | undefined, con_dmd_rec_rate?: number | undefined, current_otb_lyst?: number | undefined, dow?: string | undefined, overbooking?: number | undefined, derived_rate?: number | undefined, final_rec_rate?: number | undefined, last_current_rate?: number | undefined, market_rate_lyf?: number | undefined, market_rate_lyst?: number | undefined, occ_pct_lyst?: number | undefined, pkp_day_1_ly?: number | undefined, pkp_day_3?: number | undefined, pkp_day_3_ly?: number | undefined, pkp_day_7?: number | undefined, pkp_day_7_ly?: number | undefined, pkp_doa?: number | undefined, pkp_doa_ly?: number | undefined, transient_pkp_day_1?: number | undefined, transient_pkp_day_3?: number | undefined, transient_pkp_day_7?: number | undefined, group_pkp_day_1?: number | undefined, group_pkp_day_3?: number | undefined, group_pkp_day_7?: number | undefined, rate_variance?: number | undefined, revpar_lyf?: number | undefined, revpar?: number | undefined, sellout_ind?: boolean | undefined, revpar_lyst?: number | undefined, transient_cap?: number | undefined, unc_transient_fcst?: number | undefined, unc_dmd_curr_rate?: number | undefined, yoy_rate_lyf?: number | undefined, last_updated_date?: string | undefined, adr?: number | undefined, adr_lyst?: number | undefined, available_rooms?: number | undefined, current_otb?: number | undefined, current_otb_lyf?: number | undefined, current_rate?: number | undefined, current_revenue?: number | undefined, event_id?: string | undefined, fcst_occ_pct?: number | undefined, fcst_rev?: number | undefined, fcst_rev_rec?: number | undefined, group_blocked?: number | undefined, group_booked?: number | undefined, market_rate?: number | undefined, occ_pct?: number | undefined, occ_pct_lyf?: number | undefined, out_of_order?: number | undefined, override_rate?: number | undefined, pkp_day_1?: number | undefined, prev_rec_rate?: number | undefined, property_id?: string | undefined, rec_rate?: number | undefined, stay_date: string, total_capacity?: number | undefined, total_fcst?: number | undefined, transient_fcst?: number | undefined, transient_fcst_event?: number | undefined, yoy_rate_lyst?: number | undefined }> } | undefined, PropCompetitorSet?: { __typename?: 'PropCompSetResponse', result_rows?: number | undefined, results?: Array<{ __typename?: 'PropCompetitor', comp_id_1?: number | undefined, comp_id_2?: number | undefined, comp_id_3?: number | undefined, comp_id_4?: number | undefined, comp_id_5?: number | undefined, comp_id_6?: number | undefined, comp_id_7?: number | undefined, comp_id_8?: number | undefined, comp_id_9?: number | undefined, comp_id_10?: number | undefined, comp_name_1?: string | undefined, comp_name_2?: string | undefined, comp_name_3?: string | undefined, comp_name_4?: string | undefined, comp_name_5?: string | undefined, comp_name_6?: string | undefined, comp_name_7?: string | undefined, comp_name_8?: string | undefined, comp_name_9?: string | undefined, comp_name_10?: string | undefined, comp_rate_1?: number | undefined, comp_rate_2?: number | undefined, comp_rate_3?: number | undefined, comp_rate_4?: number | undefined, comp_rate_5?: number | undefined, comp_rate_6?: number | undefined, comp_rate_7?: number | undefined, comp_rate_8?: number | undefined, comp_rate_9?: number | undefined, comp_rate_10?: number | undefined, stay_date?: string | undefined, last_updated_date?: string | undefined } | undefined> | undefined } | undefined, getPropRateLevels?: Array<{ __typename: 'PropRateLevels', property_id?: string | undefined, stay_date?: string | undefined, a_current_otb?: number | undefined, a_fcst_sell?: number | undefined, a_rate_level?: string | undefined, a_status?: string | undefined, a_rec_action?: string | undefined, b_current_otb?: number | undefined, b_fcst_sell?: number | undefined, b_rate_level?: string | undefined, b_status?: string | undefined, b_rec_action?: string | undefined, c_current_otb?: number | undefined, c_fcst_sell?: number | undefined, c_rate_level?: string | undefined, c_status?: string | undefined, c_rec_action?: string | undefined, d_current_otb?: number | undefined, d_fcst_sell?: number | undefined, d_rate_level?: string | undefined, d_status?: string | undefined, d_rec_action?: string | undefined, e_current_otb?: number | undefined, e_fcst_sell?: number | undefined, e_rate_level?: string | undefined, e_status?: string | undefined, e_rec_action?: string | undefined, f_current_otb?: number | undefined, f_fcst_sell?: number | undefined, f_rate_level?: string | undefined, f_status?: string | undefined, f_rec_action?: string | undefined, g_fcst_sell?: number | undefined, g_current_otb?: number | undefined, g_rate_level?: string | undefined, g_status?: string | undefined, g_rec_action?: string | undefined, h_current_otb?: number | undefined, h_fcst_sell?: number | undefined, h_rate_level?: string | undefined, h_status?: string | undefined, h_rec_action?: string | undefined } | undefined> | undefined, getPropSeasons?: Array<{ __typename?: 'PropSeason', property_id?: string | undefined, season_id?: string | undefined, season_name?: string | undefined, season_start?: string | undefined, season_end?: string | undefined, selected_days: Array<string>, season_priority?: number | undefined, highlight_myview?: boolean | undefined, min_rate?: number | undefined, max_rate?: number | undefined }> | undefined };

export type GetLiveDataQueryVariables = Types.Exact<{
  propertyId: Types.Scalars['String'];
}>;


export type GetLiveDataQuery = { __typename?: 'Query', getLiveData?: Array<{ __typename?: 'LiveData', property_id?: string | undefined, snapshot_date?: string | undefined, stay_date?: string | undefined, adr_live?: number | undefined, available_rooms_live?: number | undefined, current_otb_live?: number | undefined, current_rate_live?: number | undefined, current_revenue_live?: number | undefined, group_blocked_live?: number | undefined, group_booked_live?: number | undefined, occ_pct_live?: number | undefined, ooo_live?: number | undefined, revpar_live?: number | undefined, total_capacity_live?: number | undefined, transient_booked_live?: number | undefined, transient_capacity_live?: number | undefined, a_otb_live?: number | undefined, b_otb_live?: number | undefined, c_otb_live?: number | undefined, d_otb_live?: number | undefined, e_otb_live?: number | undefined, f_otb_live?: number | undefined, g_otb_live?: number | undefined, h_otb_live?: number | undefined } | undefined> | undefined };

export type GetPropMetricsQueryVariables = Types.Exact<{
  propertyId?: Types.InputMaybe<Types.Scalars['String']>;
  input?: Types.InputMaybe<Types.SearchInfo>;
}>;


export type GetPropMetricsQuery = { __typename?: 'Query', PropMetrics?: { __typename?: 'PropRecReviewResponse', result_rows?: number | undefined, results: Array<{ __typename: 'PropRecReview', fcst_rev_rec?: number | undefined, transient_booked?: number | undefined, adr?: number | undefined, adr_lyst?: number | undefined, available_rooms?: number | undefined, current_otb?: number | undefined, current_otb_lyf?: number | undefined, current_rate?: number | undefined, current_revenue?: number | undefined, event_id?: string | undefined, fcst_occ_pct?: number | undefined, fcst_rev?: number | undefined, group_blocked?: number | undefined, group_booked?: number | undefined, market_rate?: number | undefined, occ_pct?: number | undefined, occ_pct_lyf?: number | undefined, out_of_order?: number | undefined, override_rate?: number | undefined, pkp_day_1?: number | undefined, prev_rec_rate?: number | undefined, property_id?: string | undefined, rec_rate?: number | undefined, stay_date: string, total_capacity?: number | undefined, total_fcst?: number | undefined, transient_fcst?: number | undefined, transient_fcst_event?: number | undefined, yoy_rate_lyst?: number | undefined }> } | undefined };

export type GetUserFavNightsQueryVariables = Types.Exact<{
  propertyId?: Types.InputMaybe<Types.Scalars['String']>;
  userId?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetUserFavNightsQuery = { __typename?: 'Query', listUserFavNights?: Array<{ __typename?: 'PropUserFavNight', stay_date?: string | undefined, is_favorite?: boolean | undefined, property_id?: string | undefined, user_id?: string | undefined } | undefined> | undefined };

export type GetPropRateLevelsQueryVariables = Types.Exact<{
  propertyId?: Types.InputMaybe<Types.Scalars['String']>;
  input?: Types.InputMaybe<Types.SearchInfo>;
}>;


export type GetPropRateLevelsQuery = { __typename?: 'Query', getPropRateLevels?: Array<{ __typename: 'PropRateLevels', a_current_otb?: number | undefined, a_fcst_sell?: number | undefined, a_rate_level?: string | undefined, a_status?: string | undefined, a_rec_action?: string | undefined, b_current_otb?: number | undefined, b_fcst_sell?: number | undefined, b_rate_level?: string | undefined, b_status?: string | undefined, b_rec_action?: string | undefined, c_current_otb?: number | undefined, c_fcst_sell?: number | undefined, c_rate_level?: string | undefined, c_status?: string | undefined, c_rec_action?: string | undefined, d_current_otb?: number | undefined, d_fcst_sell?: number | undefined, d_rate_level?: string | undefined, d_status?: string | undefined, d_rec_action?: string | undefined, e_current_otb?: number | undefined, e_fcst_sell?: number | undefined, e_rate_level?: string | undefined, e_status?: string | undefined, e_rec_action?: string | undefined, f_current_otb?: number | undefined, f_fcst_sell?: number | undefined, f_rate_level?: string | undefined, f_status?: string | undefined, f_rec_action?: string | undefined, g_fcst_sell?: number | undefined, g_current_otb?: number | undefined, g_rate_level?: string | undefined, g_status?: string | undefined, g_rec_action?: string | undefined, h_current_otb?: number | undefined, h_fcst_sell?: number | undefined, h_rate_level?: string | undefined, h_status?: string | undefined, h_rec_action?: string | undefined } | undefined> | undefined };

export type GetCannedSearchIdsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCannedSearchIdsQuery = { __typename?: 'Query', getCannedSearchIds?: Array<{ __typename?: 'CannedSearchIds', search_id?: number | undefined, search_name?: string | undefined } | undefined> | undefined };

export type GetRateShopQueryVariables = Types.Exact<{
  propertyId: Types.Scalars['String'];
  bar?: Types.InputMaybe<Types.Scalars['Boolean']>;
  los?: Types.InputMaybe<Types.Scalars['Int']>;
  ota?: Types.InputMaybe<Types.Scalars['String']>;
  roomType?: Types.InputMaybe<Types.Scalars['String']>;
  changeDays?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['Int']>> | Types.InputMaybe<Types.Scalars['Int']>>;
}>;


export type GetRateShopQuery = { __typename?: 'Query', getRateShop: { __typename?: 'RateShopResponse', compSet: Array<{ __typename?: 'Competitor', hotelId: number, name: string }>, dailyRates: Array<{ __typename?: 'DailyRates', stayDate: string, marketRate?: number | undefined, oneDay?: number | undefined, threeDay?: number | undefined, sevenDay?: number | undefined, rates: Array<{ __typename?: 'RateObj', hotelId: number, extractDateTime: string, arrivalDate: string, los: number, value: number, best_flex: boolean, roomName: string, message: string, changes: Array<{ __typename?: 'RateChange', day: number, value: number }> }> }> } };

export type GetPropRoomTypesQueryVariables = Types.Exact<{
  propertyId: Types.Scalars['String'];
}>;


export type GetPropRoomTypesQuery = { __typename?: 'Query', getPropRoomTypes: Array<{ __typename?: 'PropRoomType', id?: string | undefined, property_id?: string | undefined, short_desc?: string | undefined, long_desc?: string | undefined, old_roomtype?: string | undefined, room_category?: string | undefined, category_code?: string | undefined, sell_order?: number | undefined } | undefined> };

export type GetRoomTypeRecRatesQueryVariables = Types.Exact<{
  propertyId: Types.Scalars['String'];
  startDate?: Types.InputMaybe<Types.Scalars['String']>;
  endDate?: Types.InputMaybe<Types.Scalars['String']>;
  lastUpdatedDate?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetRoomTypeRecRatesQuery = { __typename?: 'Query', getRoomTypeRecRates: Array<{ __typename?: 'RoomTypeRecRate', id?: string | undefined, property_id: string, room_category_id: string, room_description?: string | undefined, current_offset?: number | undefined, recommended_offset?: number | undefined, rec_rate: number, stay_date: string, updated_at?: string | undefined } | undefined> };

export type GetDailyRateRecsQueryVariables = Types.Exact<{
  propertyId: Types.Scalars['String'];
  startDate: Types.Scalars['String'];
  endDate: Types.Scalars['String'];
}>;


export type GetDailyRateRecsQuery = { __typename?: 'Query', getDailyRateRecs?: Array<{ __typename?: 'DailyRateRecs', property_id: string, stay_date: string, updated_at?: string | undefined, conservative_rate?: number | undefined, neutral_rate?: number | undefined, aggressive_rate?: number | undefined } | undefined> | undefined };

export const CorePropMetricsFieldsFragmentDoc = gql`
    fragment CorePropMetricsFields on PropRecReview {
  __typename
  adr
  adr_lyst
  available_rooms
  current_otb
  current_otb_lyf
  current_rate
  current_revenue
  event_id
  fcst_occ_pct
  fcst_rev
  fcst_rev_rec
  group_blocked
  group_booked
  market_rate
  occ_pct
  occ_pct_lyf
  out_of_order
  override_rate
  pkp_day_1
  prev_rec_rate
  property_id
  rec_rate
  stay_date
  total_capacity
  total_fcst
  transient_fcst
  transient_fcst_event
  yoy_rate_lyst
}
    `;
export const CoreRateLevelFieldsFragmentDoc = gql`
    fragment CoreRateLevelFields on PropRateLevels {
  __typename
  a_current_otb
  a_fcst_sell
  a_rate_level
  a_status
  a_rec_action
  b_current_otb
  b_fcst_sell
  b_rate_level
  b_status
  b_rec_action
  c_current_otb
  c_fcst_sell
  c_rate_level
  c_status
  c_rec_action
  d_current_otb
  d_fcst_sell
  d_rate_level
  d_status
  d_rec_action
  e_current_otb
  e_fcst_sell
  e_rate_level
  e_status
  e_rec_action
  f_current_otb
  f_fcst_sell
  f_rate_level
  f_status
  f_rec_action
  g_fcst_sell
  g_current_otb
  g_rate_level
  g_status
  g_rec_action
  h_current_otb
  h_fcst_sell
  h_rate_level
  h_status
  h_rec_action
}
    `;
export const GetUserSearchesDocument = gql`
    query GetUserSearches($userId: String!) {
  getUserSearches(userId: $userId) {
    isEditable
    duration
    endDate
    searchCriteria {
      lhsCode
      operatorCode
      rhsCode
      rhsCustomValue
      searchId
    }
    searchId
    searchName
    searchType
    selectedDays
    startDate
    statuses
    userId
  }
}
    `;

/**
 * __useGetUserSearchesQuery__
 *
 * To run a query within a React component, call `useGetUserSearchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSearchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSearchesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserSearchesQuery(baseOptions: Apollo.QueryHookOptions<GetUserSearchesQuery, GetUserSearchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSearchesQuery, GetUserSearchesQueryVariables>(GetUserSearchesDocument, options);
      }
export function useGetUserSearchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSearchesQuery, GetUserSearchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSearchesQuery, GetUserSearchesQueryVariables>(GetUserSearchesDocument, options);
        }
export type GetUserSearchesQueryHookResult = ReturnType<typeof useGetUserSearchesQuery>;
export type GetUserSearchesLazyQueryHookResult = ReturnType<typeof useGetUserSearchesLazyQuery>;
export type GetUserSearchesQueryResult = Apollo.QueryResult<GetUserSearchesQuery, GetUserSearchesQueryVariables>;
export const GetPropertyByPropertyIdDocument = gql`
    query GetPropertyByPropertyId($propertyId: String!) {
  getPropertyByPropertyId(propertyId: $propertyId) {
    property_id
    search_name
    currency_code
    full_history_avail_ind
  }
}
    `;

/**
 * __useGetPropertyByPropertyIdQuery__
 *
 * To run a query within a React component, call `useGetPropertyByPropertyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyByPropertyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyByPropertyIdQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetPropertyByPropertyIdQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyByPropertyIdQuery, GetPropertyByPropertyIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyByPropertyIdQuery, GetPropertyByPropertyIdQueryVariables>(GetPropertyByPropertyIdDocument, options);
      }
export function useGetPropertyByPropertyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyByPropertyIdQuery, GetPropertyByPropertyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyByPropertyIdQuery, GetPropertyByPropertyIdQueryVariables>(GetPropertyByPropertyIdDocument, options);
        }
export type GetPropertyByPropertyIdQueryHookResult = ReturnType<typeof useGetPropertyByPropertyIdQuery>;
export type GetPropertyByPropertyIdLazyQueryHookResult = ReturnType<typeof useGetPropertyByPropertyIdLazyQuery>;
export type GetPropertyByPropertyIdQueryResult = Apollo.QueryResult<GetPropertyByPropertyIdQuery, GetPropertyByPropertyIdQueryVariables>;
export const GetPropertiesDocument = gql`
    query GetProperties($searchTerm: String!) {
  getProperties(searchTerm: $searchTerm) {
    search_name
    property_id
    currency_code
  }
}
    `;

/**
 * __useGetPropertiesQuery__
 *
 * To run a query within a React component, call `useGetPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertiesQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetPropertiesQuery(baseOptions: Apollo.QueryHookOptions<GetPropertiesQuery, GetPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertiesQuery, GetPropertiesQueryVariables>(GetPropertiesDocument, options);
      }
export function useGetPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertiesQuery, GetPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertiesQuery, GetPropertiesQueryVariables>(GetPropertiesDocument, options);
        }
export type GetPropertiesQueryHookResult = ReturnType<typeof useGetPropertiesQuery>;
export type GetPropertiesLazyQueryHookResult = ReturnType<typeof useGetPropertiesLazyQuery>;
export type GetPropertiesQueryResult = Apollo.QueryResult<GetPropertiesQuery, GetPropertiesQueryVariables>;
export const GetSelloutIndicatorsDocument = gql`
    query GetSelloutIndicators($propertyId: String!, $stayDate: String!) {
  getSelloutReasons(propertyId: $propertyId, stayDate: $stayDate)
}
    `;

/**
 * __useGetSelloutIndicatorsQuery__
 *
 * To run a query within a React component, call `useGetSelloutIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelloutIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelloutIndicatorsQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      stayDate: // value for 'stayDate'
 *   },
 * });
 */
export function useGetSelloutIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<GetSelloutIndicatorsQuery, GetSelloutIndicatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelloutIndicatorsQuery, GetSelloutIndicatorsQueryVariables>(GetSelloutIndicatorsDocument, options);
      }
export function useGetSelloutIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelloutIndicatorsQuery, GetSelloutIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelloutIndicatorsQuery, GetSelloutIndicatorsQueryVariables>(GetSelloutIndicatorsDocument, options);
        }
export type GetSelloutIndicatorsQueryHookResult = ReturnType<typeof useGetSelloutIndicatorsQuery>;
export type GetSelloutIndicatorsLazyQueryHookResult = ReturnType<typeof useGetSelloutIndicatorsLazyQuery>;
export type GetSelloutIndicatorsQueryResult = Apollo.QueryResult<GetSelloutIndicatorsQuery, GetSelloutIndicatorsQueryVariables>;
export const SaveSearchDocument = gql`
    mutation SaveSearch($search: SearchInput) {
  saveSearch(search: $search) {
    isEditable
    duration
    endDate
    searchCriteria {
      lhsCode
      operatorCode
      rhsCode
      rhsCustomValue
      searchId
    }
    searchId
    searchName
    searchType
    selectedDays
    startDate
    statuses
    userId
  }
}
    `;
export type SaveSearchMutationFn = Apollo.MutationFunction<SaveSearchMutation, SaveSearchMutationVariables>;

/**
 * __useSaveSearchMutation__
 *
 * To run a mutation, you first call `useSaveSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSearchMutation, { data, loading, error }] = useSaveSearchMutation({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSaveSearchMutation(baseOptions?: Apollo.MutationHookOptions<SaveSearchMutation, SaveSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSearchMutation, SaveSearchMutationVariables>(SaveSearchDocument, options);
      }
export type SaveSearchMutationHookResult = ReturnType<typeof useSaveSearchMutation>;
export type SaveSearchMutationResult = Apollo.MutationResult<SaveSearchMutation>;
export type SaveSearchMutationOptions = Apollo.BaseMutationOptions<SaveSearchMutation, SaveSearchMutationVariables>;
export const DeleteSearchDocument = gql`
    mutation DeleteSearch($searchId: Int) {
  deleteSearch(searchId: $searchId) {
    success
    message
  }
}
    `;
export type DeleteSearchMutationFn = Apollo.MutationFunction<DeleteSearchMutation, DeleteSearchMutationVariables>;

/**
 * __useDeleteSearchMutation__
 *
 * To run a mutation, you first call `useDeleteSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSearchMutation, { data, loading, error }] = useDeleteSearchMutation({
 *   variables: {
 *      searchId: // value for 'searchId'
 *   },
 * });
 */
export function useDeleteSearchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSearchMutation, DeleteSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSearchMutation, DeleteSearchMutationVariables>(DeleteSearchDocument, options);
      }
export type DeleteSearchMutationHookResult = ReturnType<typeof useDeleteSearchMutation>;
export type DeleteSearchMutationResult = Apollo.MutationResult<DeleteSearchMutation>;
export type DeleteSearchMutationOptions = Apollo.BaseMutationOptions<DeleteSearchMutation, DeleteSearchMutationVariables>;
export const ToggleFavoriteStayNightDocument = gql`
    mutation ToggleFavoriteStayNight($propertyId: String!, $stayDate: String!, $userId: String!) {
  favoriteStayNight(propertyId: $propertyId, stayDate: $stayDate, userId: $userId) {
    stay_date
    is_favorite
    property_id
    user_id
  }
}
    `;
export type ToggleFavoriteStayNightMutationFn = Apollo.MutationFunction<ToggleFavoriteStayNightMutation, ToggleFavoriteStayNightMutationVariables>;

/**
 * __useToggleFavoriteStayNightMutation__
 *
 * To run a mutation, you first call `useToggleFavoriteStayNightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleFavoriteStayNightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleFavoriteStayNightMutation, { data, loading, error }] = useToggleFavoriteStayNightMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      stayDate: // value for 'stayDate'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useToggleFavoriteStayNightMutation(baseOptions?: Apollo.MutationHookOptions<ToggleFavoriteStayNightMutation, ToggleFavoriteStayNightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleFavoriteStayNightMutation, ToggleFavoriteStayNightMutationVariables>(ToggleFavoriteStayNightDocument, options);
      }
export type ToggleFavoriteStayNightMutationHookResult = ReturnType<typeof useToggleFavoriteStayNightMutation>;
export type ToggleFavoriteStayNightMutationResult = Apollo.MutationResult<ToggleFavoriteStayNightMutation>;
export type ToggleFavoriteStayNightMutationOptions = Apollo.BaseMutationOptions<ToggleFavoriteStayNightMutation, ToggleFavoriteStayNightMutationVariables>;
export const GetSearchMetricsDocument = gql`
    query GetSearchMetrics {
  getSearchMetrics {
    lhsCode
    lhsName
    operator {
      code
      value
    }
    rhs {
      code
      value
    }
  }
}
    `;

/**
 * __useGetSearchMetricsQuery__
 *
 * To run a query within a React component, call `useGetSearchMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSearchMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchMetricsQuery, GetSearchMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchMetricsQuery, GetSearchMetricsQueryVariables>(GetSearchMetricsDocument, options);
      }
export function useGetSearchMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchMetricsQuery, GetSearchMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchMetricsQuery, GetSearchMetricsQueryVariables>(GetSearchMetricsDocument, options);
        }
export type GetSearchMetricsQueryHookResult = ReturnType<typeof useGetSearchMetricsQuery>;
export type GetSearchMetricsLazyQueryHookResult = ReturnType<typeof useGetSearchMetricsLazyQuery>;
export type GetSearchMetricsQueryResult = Apollo.QueryResult<GetSearchMetricsQuery, GetSearchMetricsQueryVariables>;
export const GetRecReviewDataDocument = gql`
    query GetRecReviewData($propertyId: String, $input: SearchInfo) {
  PropMetrics(propertyId: $propertyId, input: $input) {
    result_rows
    results {
      ...CorePropMetricsFields
      adr_lyf
      available_cap
      con_dmd_curr_rate
      con_dmd_rec_rate
      current_otb_lyst
      dow
      overbooking
      derived_rate
      final_rec_rate
      last_current_rate
      market_rate_lyf
      market_rate_lyst
      occ_pct_lyst
      pkp_day_1_ly
      pkp_day_3
      pkp_day_3_ly
      pkp_day_7
      pkp_day_7_ly
      pkp_doa
      pkp_doa_ly
      transient_pkp_day_1
      transient_pkp_day_3
      transient_pkp_day_7
      group_pkp_day_1
      group_pkp_day_3
      group_pkp_day_7
      rate_variance
      revpar_lyf
      revpar
      sellout_ind
      revpar_lyst
      transient_cap
      unc_transient_fcst
      unc_dmd_curr_rate
      yoy_rate_lyf
      last_updated_date
    }
  }
  PropCompetitorSet(propertyId: $propertyId, input: $input) {
    result_rows
    results {
      comp_id_1
      comp_id_2
      comp_id_3
      comp_id_4
      comp_id_5
      comp_id_6
      comp_id_7
      comp_id_8
      comp_id_9
      comp_id_10
      comp_name_1
      comp_name_2
      comp_name_3
      comp_name_4
      comp_name_5
      comp_name_6
      comp_name_7
      comp_name_8
      comp_name_9
      comp_name_10
      comp_rate_1
      comp_rate_2
      comp_rate_3
      comp_rate_4
      comp_rate_5
      comp_rate_6
      comp_rate_7
      comp_rate_8
      comp_rate_9
      comp_rate_10
      stay_date
      last_updated_date
    }
  }
  getPropRateLevels(propertyId: $propertyId, input: $input) {
    ...CoreRateLevelFields
    property_id
    stay_date
  }
  getPropSeasons(propertyId: $propertyId) {
    property_id
    season_id
    season_name
    season_start
    season_end
    selected_days
    season_priority
    highlight_myview
    min_rate
    max_rate
  }
}
    ${CorePropMetricsFieldsFragmentDoc}
${CoreRateLevelFieldsFragmentDoc}`;

/**
 * __useGetRecReviewDataQuery__
 *
 * To run a query within a React component, call `useGetRecReviewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecReviewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecReviewDataQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRecReviewDataQuery(baseOptions?: Apollo.QueryHookOptions<GetRecReviewDataQuery, GetRecReviewDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecReviewDataQuery, GetRecReviewDataQueryVariables>(GetRecReviewDataDocument, options);
      }
export function useGetRecReviewDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecReviewDataQuery, GetRecReviewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecReviewDataQuery, GetRecReviewDataQueryVariables>(GetRecReviewDataDocument, options);
        }
export type GetRecReviewDataQueryHookResult = ReturnType<typeof useGetRecReviewDataQuery>;
export type GetRecReviewDataLazyQueryHookResult = ReturnType<typeof useGetRecReviewDataLazyQuery>;
export type GetRecReviewDataQueryResult = Apollo.QueryResult<GetRecReviewDataQuery, GetRecReviewDataQueryVariables>;
export const GetLiveDataDocument = gql`
    query GetLiveData($propertyId: String!) {
  getLiveData(propertyId: $propertyId) {
    property_id
    snapshot_date
    stay_date
    adr_live
    available_rooms_live
    current_otb_live
    current_rate_live
    current_revenue_live
    group_blocked_live
    group_booked_live
    occ_pct_live
    ooo_live
    revpar_live
    total_capacity_live
    transient_booked_live
    transient_capacity_live
    a_otb_live
    b_otb_live
    c_otb_live
    d_otb_live
    e_otb_live
    f_otb_live
    g_otb_live
    h_otb_live
  }
}
    `;

/**
 * __useGetLiveDataQuery__
 *
 * To run a query within a React component, call `useGetLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiveDataQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetLiveDataQuery(baseOptions: Apollo.QueryHookOptions<GetLiveDataQuery, GetLiveDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLiveDataQuery, GetLiveDataQueryVariables>(GetLiveDataDocument, options);
      }
export function useGetLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLiveDataQuery, GetLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLiveDataQuery, GetLiveDataQueryVariables>(GetLiveDataDocument, options);
        }
export type GetLiveDataQueryHookResult = ReturnType<typeof useGetLiveDataQuery>;
export type GetLiveDataLazyQueryHookResult = ReturnType<typeof useGetLiveDataLazyQuery>;
export type GetLiveDataQueryResult = Apollo.QueryResult<GetLiveDataQuery, GetLiveDataQueryVariables>;
export const GetPropMetricsDocument = gql`
    query GetPropMetrics($propertyId: String, $input: SearchInfo) {
  PropMetrics(propertyId: $propertyId, input: $input) {
    result_rows
    results {
      ...CorePropMetricsFields
      fcst_rev_rec
      transient_booked
    }
  }
}
    ${CorePropMetricsFieldsFragmentDoc}`;

/**
 * __useGetPropMetricsQuery__
 *
 * To run a query within a React component, call `useGetPropMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropMetricsQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPropMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetPropMetricsQuery, GetPropMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropMetricsQuery, GetPropMetricsQueryVariables>(GetPropMetricsDocument, options);
      }
export function useGetPropMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropMetricsQuery, GetPropMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropMetricsQuery, GetPropMetricsQueryVariables>(GetPropMetricsDocument, options);
        }
export type GetPropMetricsQueryHookResult = ReturnType<typeof useGetPropMetricsQuery>;
export type GetPropMetricsLazyQueryHookResult = ReturnType<typeof useGetPropMetricsLazyQuery>;
export type GetPropMetricsQueryResult = Apollo.QueryResult<GetPropMetricsQuery, GetPropMetricsQueryVariables>;
export const GetUserFavNightsDocument = gql`
    query GetUserFavNights($propertyId: String, $userId: String) {
  listUserFavNights(propertyId: $propertyId, userId: $userId) {
    stay_date
    is_favorite
    property_id
    user_id
  }
}
    `;

/**
 * __useGetUserFavNightsQuery__
 *
 * To run a query within a React component, call `useGetUserFavNightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFavNightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFavNightsQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserFavNightsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserFavNightsQuery, GetUserFavNightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFavNightsQuery, GetUserFavNightsQueryVariables>(GetUserFavNightsDocument, options);
      }
export function useGetUserFavNightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFavNightsQuery, GetUserFavNightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFavNightsQuery, GetUserFavNightsQueryVariables>(GetUserFavNightsDocument, options);
        }
export type GetUserFavNightsQueryHookResult = ReturnType<typeof useGetUserFavNightsQuery>;
export type GetUserFavNightsLazyQueryHookResult = ReturnType<typeof useGetUserFavNightsLazyQuery>;
export type GetUserFavNightsQueryResult = Apollo.QueryResult<GetUserFavNightsQuery, GetUserFavNightsQueryVariables>;
export const GetPropRateLevelsDocument = gql`
    query GetPropRateLevels($propertyId: String, $input: SearchInfo) {
  getPropRateLevels(propertyId: $propertyId, input: $input) {
    ...CoreRateLevelFields
  }
}
    ${CoreRateLevelFieldsFragmentDoc}`;

/**
 * __useGetPropRateLevelsQuery__
 *
 * To run a query within a React component, call `useGetPropRateLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropRateLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropRateLevelsQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPropRateLevelsQuery(baseOptions?: Apollo.QueryHookOptions<GetPropRateLevelsQuery, GetPropRateLevelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropRateLevelsQuery, GetPropRateLevelsQueryVariables>(GetPropRateLevelsDocument, options);
      }
export function useGetPropRateLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropRateLevelsQuery, GetPropRateLevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropRateLevelsQuery, GetPropRateLevelsQueryVariables>(GetPropRateLevelsDocument, options);
        }
export type GetPropRateLevelsQueryHookResult = ReturnType<typeof useGetPropRateLevelsQuery>;
export type GetPropRateLevelsLazyQueryHookResult = ReturnType<typeof useGetPropRateLevelsLazyQuery>;
export type GetPropRateLevelsQueryResult = Apollo.QueryResult<GetPropRateLevelsQuery, GetPropRateLevelsQueryVariables>;
export const GetCannedSearchIdsDocument = gql`
    query GetCannedSearchIds {
  getCannedSearchIds {
    search_id
    search_name
  }
}
    `;

/**
 * __useGetCannedSearchIdsQuery__
 *
 * To run a query within a React component, call `useGetCannedSearchIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCannedSearchIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCannedSearchIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCannedSearchIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetCannedSearchIdsQuery, GetCannedSearchIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCannedSearchIdsQuery, GetCannedSearchIdsQueryVariables>(GetCannedSearchIdsDocument, options);
      }
export function useGetCannedSearchIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCannedSearchIdsQuery, GetCannedSearchIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCannedSearchIdsQuery, GetCannedSearchIdsQueryVariables>(GetCannedSearchIdsDocument, options);
        }
export type GetCannedSearchIdsQueryHookResult = ReturnType<typeof useGetCannedSearchIdsQuery>;
export type GetCannedSearchIdsLazyQueryHookResult = ReturnType<typeof useGetCannedSearchIdsLazyQuery>;
export type GetCannedSearchIdsQueryResult = Apollo.QueryResult<GetCannedSearchIdsQuery, GetCannedSearchIdsQueryVariables>;
export const GetRateShopDocument = gql`
    query GetRateShop($propertyId: String!, $bar: Boolean, $los: Int, $ota: String, $roomType: String, $changeDays: [Int]) {
  getRateShop(
    propertyId: $propertyId
    bar: $bar
    los: $los
    ota: $ota
    roomType: $roomType
    changeDays: $changeDays
  ) {
    compSet {
      hotelId
      name
    }
    dailyRates {
      stayDate
      marketRate
      oneDay
      threeDay
      sevenDay
      rates {
        hotelId
        extractDateTime
        arrivalDate
        los
        value
        best_flex
        roomName
        message
        changes {
          day
          value
        }
      }
    }
  }
}
    `;

/**
 * __useGetRateShopQuery__
 *
 * To run a query within a React component, call `useGetRateShopQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRateShopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRateShopQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      bar: // value for 'bar'
 *      los: // value for 'los'
 *      ota: // value for 'ota'
 *      roomType: // value for 'roomType'
 *      changeDays: // value for 'changeDays'
 *   },
 * });
 */
export function useGetRateShopQuery(baseOptions: Apollo.QueryHookOptions<GetRateShopQuery, GetRateShopQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRateShopQuery, GetRateShopQueryVariables>(GetRateShopDocument, options);
      }
export function useGetRateShopLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRateShopQuery, GetRateShopQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRateShopQuery, GetRateShopQueryVariables>(GetRateShopDocument, options);
        }
export type GetRateShopQueryHookResult = ReturnType<typeof useGetRateShopQuery>;
export type GetRateShopLazyQueryHookResult = ReturnType<typeof useGetRateShopLazyQuery>;
export type GetRateShopQueryResult = Apollo.QueryResult<GetRateShopQuery, GetRateShopQueryVariables>;
export const GetPropRoomTypesDocument = gql`
    query GetPropRoomTypes($propertyId: String!) {
  getPropRoomTypes(propertyId: $propertyId) {
    id
    property_id
    short_desc
    long_desc
    old_roomtype
    room_category
    category_code
    sell_order
  }
}
    `;

/**
 * __useGetPropRoomTypesQuery__
 *
 * To run a query within a React component, call `useGetPropRoomTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropRoomTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropRoomTypesQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetPropRoomTypesQuery(baseOptions: Apollo.QueryHookOptions<GetPropRoomTypesQuery, GetPropRoomTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropRoomTypesQuery, GetPropRoomTypesQueryVariables>(GetPropRoomTypesDocument, options);
      }
export function useGetPropRoomTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropRoomTypesQuery, GetPropRoomTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropRoomTypesQuery, GetPropRoomTypesQueryVariables>(GetPropRoomTypesDocument, options);
        }
export type GetPropRoomTypesQueryHookResult = ReturnType<typeof useGetPropRoomTypesQuery>;
export type GetPropRoomTypesLazyQueryHookResult = ReturnType<typeof useGetPropRoomTypesLazyQuery>;
export type GetPropRoomTypesQueryResult = Apollo.QueryResult<GetPropRoomTypesQuery, GetPropRoomTypesQueryVariables>;
export const GetRoomTypeRecRatesDocument = gql`
    query GetRoomTypeRecRates($propertyId: String!, $startDate: String, $endDate: String, $lastUpdatedDate: String) {
  getRoomTypeRecRates(
    propertyId: $propertyId
    startDate: $startDate
    endDate: $endDate
    lastUpdatedDate: $lastUpdatedDate
  ) {
    id
    property_id
    room_category_id
    room_description
    current_offset
    recommended_offset
    rec_rate
    stay_date
    updated_at
  }
}
    `;

/**
 * __useGetRoomTypeRecRatesQuery__
 *
 * To run a query within a React component, call `useGetRoomTypeRecRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomTypeRecRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomTypeRecRatesQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      lastUpdatedDate: // value for 'lastUpdatedDate'
 *   },
 * });
 */
export function useGetRoomTypeRecRatesQuery(baseOptions: Apollo.QueryHookOptions<GetRoomTypeRecRatesQuery, GetRoomTypeRecRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomTypeRecRatesQuery, GetRoomTypeRecRatesQueryVariables>(GetRoomTypeRecRatesDocument, options);
      }
export function useGetRoomTypeRecRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomTypeRecRatesQuery, GetRoomTypeRecRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomTypeRecRatesQuery, GetRoomTypeRecRatesQueryVariables>(GetRoomTypeRecRatesDocument, options);
        }
export type GetRoomTypeRecRatesQueryHookResult = ReturnType<typeof useGetRoomTypeRecRatesQuery>;
export type GetRoomTypeRecRatesLazyQueryHookResult = ReturnType<typeof useGetRoomTypeRecRatesLazyQuery>;
export type GetRoomTypeRecRatesQueryResult = Apollo.QueryResult<GetRoomTypeRecRatesQuery, GetRoomTypeRecRatesQueryVariables>;
export const GetDailyRateRecsDocument = gql`
    query GetDailyRateRecs($propertyId: String!, $startDate: String!, $endDate: String!) {
  getDailyRateRecs(
    propertyId: $propertyId
    startDate: $startDate
    endDate: $endDate
  ) {
    property_id
    stay_date
    updated_at
    conservative_rate
    neutral_rate
    aggressive_rate
  }
}
    `;

/**
 * __useGetDailyRateRecsQuery__
 *
 * To run a query within a React component, call `useGetDailyRateRecsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyRateRecsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyRateRecsQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetDailyRateRecsQuery(baseOptions: Apollo.QueryHookOptions<GetDailyRateRecsQuery, GetDailyRateRecsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyRateRecsQuery, GetDailyRateRecsQueryVariables>(GetDailyRateRecsDocument, options);
      }
export function useGetDailyRateRecsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyRateRecsQuery, GetDailyRateRecsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyRateRecsQuery, GetDailyRateRecsQueryVariables>(GetDailyRateRecsDocument, options);
        }
export type GetDailyRateRecsQueryHookResult = ReturnType<typeof useGetDailyRateRecsQuery>;
export type GetDailyRateRecsLazyQueryHookResult = ReturnType<typeof useGetDailyRateRecsLazyQuery>;
export type GetDailyRateRecsQueryResult = Apollo.QueryResult<GetDailyRateRecsQuery, GetDailyRateRecsQueryVariables>;
export const namedOperations = {
  Query: {
    GetUserSearches: 'GetUserSearches',
    GetPropertyByPropertyId: 'GetPropertyByPropertyId',
    GetProperties: 'GetProperties',
    GetSelloutIndicators: 'GetSelloutIndicators',
    GetSearchMetrics: 'GetSearchMetrics',
    GetRecReviewData: 'GetRecReviewData',
    GetLiveData: 'GetLiveData',
    GetPropMetrics: 'GetPropMetrics',
    GetUserFavNights: 'GetUserFavNights',
    GetPropRateLevels: 'GetPropRateLevels',
    GetCannedSearchIds: 'GetCannedSearchIds',
    GetRateShop: 'GetRateShop',
    GetPropRoomTypes: 'GetPropRoomTypes',
    GetRoomTypeRecRates: 'GetRoomTypeRecRates',
    GetDailyRateRecs: 'GetDailyRateRecs'
  },
  Mutation: {
    SaveSearch: 'SaveSearch',
    DeleteSearch: 'DeleteSearch',
    ToggleFavoriteStayNight: 'ToggleFavoriteStayNight'
  },
  Fragment: {
    CorePropMetricsFields: 'CorePropMetricsFields',
    CoreRateLevelFields: 'CoreRateLevelFields'
  }
}